/* eslint-disable sonarjs/cognitive-complexity, react-hooks/exhaustive-deps, react/forbid-component-props */
import { faMapMarkerAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState, useContext, useEffect } from 'react';
import ReactCookies, { select } from 'react-cookies';
import { useDispatch } from 'react-redux';
import { Element, scroller } from 'react-scroll';
import {
  LIGHTBOX_BELOW_BUTTON,
  LIGHTBOX_ABOVE_BUTTON,
  MODALS,
} from '../../../config/constants/lightbox';
import {
  SUBSCRIBER_TEST_IDS,
  PPC_SIGN_UP,
} from '../../../config/constants/ppc';
import COOKIES from '../../../config/cookies/cookies';
import { LINK_LOGIN } from '../../../config/links/links';
import {
  DEFAULT_LOCATION,
  EMAIL_INPUT_SCROLL_TO_ID,
  LIGHTBOX_APPEARED,
} from '../../../config/setup/setup';
import {
  AND,
  GO_TO_DEALS,
  SAVE_EIGHTY_WHERE_YOU_LIVE,
  SUBSCRIPTION_EMAIL_IS_REQUIRED,
  TOASTRMSG,
  SIGN_UP_WITH_GOOGLE,
  LEAVE_BLANK,
  DID_YOU_MEAN,
  KICKBOX_FAILED_VALIDATION,
  DELIVERABLE,
  RISKY,
  UNDELIVERABLE,
  UNKNOWN,
  SUBSCRIPTION_LOCATION_IS_REQUIRED,
  CHOOSE_YOUR_LOCATION,
} from '../../../config/text/text';
import { updateTrackingLocation } from '../../../helpers/analytics';
import commonCookiesOptions from '../../../helpers/commonCookiesOptions';
import {
  removeCookie,
  setCookie,
  setPostLoginUrl,
  setSubscribedBrandWinCookie,
} from '../../../helpers/cookieSetter';
import ErrorTrackingService from '../../../helpers/errorTrackingService';
import { onSelectLocationHelper } from '../../../helpers/location';
import { isMobileViewport, useScreenBreakpoint } from '../../../helpers/screen';
import { redirectToURL, parseWowcherPath } from '../../../helpers/url';
import { validateEmail } from '../../../helpers/validations';
import ThemeContext from '../../../providers/ThemeProvider';
import Icon from '../../Icon';
import Message from '../../_generic/Message';
import { sendBotAlert } from '../../_generic/axiosSplunk/axiosSplunk';
import BareSelect from '../../_generic/form/BareSelect';
import Spinner from '../../_generic/spinner/Spinner';
import TextDevider from '../../_generic/textDevider/TextDevider';
import useToast from '../../_generic/toast/UseToast';
import HeaderLogo from '../../header/HeaderLogo';
import LoginGoogle from '../../mediaButtons/GoogleButton';
import { getSubscriberStyle } from './Subscriber.style';
import {
  trackEmailEvent,
  trackHomepageLinkEvent,
  setAxiosConfig,
  redirectToWPSUrl,
  redirectToLocationPage,
  checkKickbox,
} from './Subscriber.util';
import { SubscriberButtons } from './SubscriberButtons';
import { Input, Button } from './components';
import WelcomePageLayouts from './components/welcomePageLayouts';

export const Subscriber = ({
  isLightBox = false,
  isBadConnection = false,
  setShowModal = () => {},
  showCloseIcon = false,
  list,
  subTitle,
  defaultLocation,
  buttonText,
  redirectUrl = '',
  isLocation = false,
  isAuthenticated = false,
  mobileImageUrl,
  desktopImageUrl,
  welcomePageTest,
}) => {
  const [showError, setShowError] = useState(false);
  const [showErrorForLocation, setShowErrorForLocation] = useState(false);
  const [showKickboxError, setShowKickboxError] = useState(false);
  const [fieldonfocus, setOnFocus] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const toast = useToast();
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [botField, setBotField] = useState('');
  const router = useRouter();
  const userLocationCookie = ReactCookies.load(COOKIES.location);

  const urlHasLocationLightbox = isLocation && isLightBox;
  const breakpoint = useScreenBreakpoint();

  const [isMobile, setIsMobile] = useState(false);
  const [suggestedMail, setSuggestedMail] = useState('');
  // Read the welcome-page cookie
  let welcomePageCookie = ReactCookies.load(COOKIES.welcomePage);

  // If the cookie does not exist and welcomePageTest is available, set the cookie
  if (!welcomePageCookie && welcomePageTest) {
    ReactCookies.save(
      COOKIES.welcomePage,
      welcomePageTest,
      commonCookiesOptions,
    );
    welcomePageCookie = welcomePageTest; // Assign the newly set value to the variable
  }

  useEffect(() => {
    attachTrackingEventListener();

    return () => {
      removeTrackingEventListener();
    };
  }, []);

  const handleClickTrackedLink = async (event) => {
    await trackHomepageLinkEvent();

    return true;
  };

  const attachTrackingEventListener = () => {
    const button = document.querySelector('#homepage-link-track');
    if (button) {
      button.addEventListener('click', handleClickTrackedLink);
    }
  };

  const removeTrackingEventListener = () => {
    const button = document.querySelector('#homepage-link-track');
    if (button) {
      button.removeEventListener('click', handleClickTrackedLink);
    }
  };

  useEffect(() => {
    attachTrackingEventListener();

    return () => {
      removeTrackingEventListener();
    };
  }, []);

  useEffect(() => {
    setIsMobile(isMobileViewport());
  }, [breakpoint]);

  const handleCloseButton = () => {
    setShowModal(false);
    localStorage.setItem(LIGHTBOX_APPEARED, JSON.stringify('exists'));

    // If the brand is not wowcher and brandCookie is not present
    const brandCookie = ReactCookies.load(COOKIES.brandCookie);
    if (!brandCookie && process.env.NEXT_PUBLIC_SITE !== 'wowcher') {
      setCookie({
        key: COOKIES.brandCookie,
        value: 'bypass_temp',
      });
    }
    if (isBadConnection) {
      const cookieExpire = dayjs().add(365, 'days').toISOString();

      ReactCookies.save(COOKIES.lightboxClosed, 'true', {
        ...commonCookiesOptions,
        expires: new Date(cookieExpire),
      });
    }
  };
  useEffect(() => {
    const close = (event) => {
      if (event.keyCode === 27 || event.key === 'Escape') {
        handleCloseButton();
      }
    };
    window.addEventListener('keydown', close, true);
  }, []);
  const [locationAux, setSelectLocation] = useState(CHOOSE_YOUR_LOCATION);

  const onChangeAction = (value) => {
    setSelectLocation(value);
    setShowErrorForLocation(false);
  };

  useEffect(() => {
    if (ReactCookies.load(COOKIES.lightboxClosed)) {
      ReactCookies.remove(COOKIES.lightboxClosed, {
        domain: `.${process.env.NEXT_PUBLIC_DOMAIN_NAME}`,
        path: '/',
      });
    }
  }, []);

  const theme = useContext(ThemeContext);
  const {
    SUBMIT_BUTTON,
    GOOGLE_BUTTON,
    SUBTITLE_TEXT,
    ERROR_TEXT,
    LOCATION_SELECT,
  } = SUBSCRIBER_TEST_IDS;

  const updatedList = [
    { name: CHOOSE_YOUR_LOCATION, value: '' },
    ...list.map((element) => ({
      name: element.name,
      value: element.shortName,
    })),
  ];

  const goToLogin = () => {
    setPostLoginUrl(router.asPath);
    redirectToURL(LINK_LOGIN, router);
  };

  const setNewUserLocation = () => {
    return list.find((locationObject) => {
      if (locationObject.shortName === locationAux) {
        return locationObject;
      }

      return null;
    });
  };

  const handleCTCookie = (customerToken) => {
    if (!ReactCookies.load(COOKIES.customerToken)) {
      const expires = new Date();
      expires.setDate(expires.getDate() + 365);

      ReactCookies.save(COOKIES.customerToken, customerToken, {
        ...commonCookiesOptions,
        expires,
      });
    }
  };

  const handleOnSubscribed = (token) => {
    // BRAND-win (wowcher-win or livingsocial-win)
    setSubscribedBrandWinCookie();
    // Handle CT cookie
    handleCTCookie(token);

    // Check if the user has selected location on lightbox
    if (setNewUserLocation()?.shortName !== userLocationCookie?.shortName) {
      onSelectLocationHelper(setNewUserLocation(), dispatch, router);
    }
  };

  const notifyError = (message) => {
    toast.addToast(message, 'toast-error');
  };

  const subscribeCall = async (userEmail, selectedLocation) => {
    try {
      setShowSpinner(true);
      const response = await setAxiosConfig(userEmail, selectedLocation);

      if (response?.data) {
        const { newEmail, status, token, message } = response.data;
        setShowSpinner(false);
        trackEmailEvent(newEmail);
        if (ReactCookies.load(COOKIES.userEmail)) {
          removeCookie(COOKIES.userEmail);
        }
        setCookie({
          expire: 365,
          key: COOKIES.userEmail,
          value: userEmail,
        });

        if (status === 'success') {
          handleOnSubscribed(token);
          if (!isEmpty(redirectUrl)) {
            redirectToWPSUrl(redirectUrl, selectedLocation, router);
          }
          if (urlHasLocationLightbox) {
            redirectToLocationPage({
              location: selectedLocation,
              originalUrl: router.asPath,
              router,
            });
          }
          setShowModal(false);
          if (selectedLocation)
            updateTrackingLocation(selectedLocation, 'dropdown_lightbox');
          localStorage.setItem(LIGHTBOX_APPEARED, JSON.stringify('exists'));
        } else {
          notifyError(message || TOASTRMSG);
        }

        return true;
      } else {
        setShowSpinner(false);
        notifyError(TOASTRMSG);

        return false;
      }
    } catch (error) {
      // Show error if is needed
      setShowSpinner(false);
      notifyError(TOASTRMSG);
      ErrorTrackingService.logError(`Problem with subscription: ${error}`);

      return false;
    }
  };

  const changeEmail = (event) => {
    setEmail(event.target.value);
    if (showError) setShowError(false);
  };

  const handleHoneyPotField = (event) => {
    setBotField(event.target.value);
  };
  const subscribe = async () => {
    if (botField.length > 0) {
      setShowModal(false);
      localStorage.setItem(LIGHTBOX_APPEARED, JSON.stringify('exists'));
      sendBotAlert(router);

      return;
    }

    if (!locationAux || locationAux === CHOOSE_YOUR_LOCATION) {
      setShowErrorForLocation(true);
    } else if (validateEmail(email)) {
      const encodedEmail = encodeURIComponent(email);
      const response = await checkKickbox(encodedEmail);
      if (
        response?.data?.result === DELIVERABLE ||
        response?.data?.result === RISKY
      ) {
        subscribeCall(email, locationAux);
      } else {
        if (response?.data?.didYouMean) {
          setSuggestedMail(response?.data?.didYouMean);
        }
        if (
          response?.data?.result === UNDELIVERABLE ||
          response?.data?.result === UNKNOWN
        ) {
          setShowKickboxError(true);
        }
      }
    } else {
      setShowError(true);
    }
  };

  // To refactor, business logic mixed with styling
  const componentClass = classNames(
    `subscribeModal-container subscriber-wrapper`,
    {
      'green-input': validateEmail(email),
      'grey-input': !fieldonfocus && !validateEmail(email),
      'red-input': !validateEmail(email) && fieldonfocus,
    },
  );

  const layoutShiftValues = ['b', 'c', 'd', 'e', 'f'];

  if (
    router.asPath.includes('/welcome/') &&
    welcomePageCookie &&
    layoutShiftValues.includes(welcomePageCookie)
  ) {
    return (
      <WelcomePageLayouts
        botField={botField}
        buttonText={buttonText || GO_TO_DEALS}
        changeEmail={changeEmail}
        desktopImageUrl={desktopImageUrl}
        email={email}
        handleHoneyPotField={handleHoneyPotField}
        isAuthenticated={isAuthenticated}
        isMobile={isMobile}
        list={list}
        locationAux={locationAux}
        mobileImageUrl={mobileImageUrl}
        onChangeAction={onChangeAction}
        redirectUrl={redirectUrl}
        setShowModal={setShowModal}
        showError={showError}
        showErrorForLocation={showErrorForLocation}
        showKickboxError={showKickboxError}
        showSpinner={showSpinner}
        subTitle={subTitle}
        subscribe={subscribe}
        suggestedMail={suggestedMail}
        updatedList={updatedList}
        variant={welcomePageCookie}
      />
    );
  }

  return (
    <>
      <div className={componentClass}>
        {showSpinner && <Spinner />}
        <div className="form-group">
          <div className="header-bar row">
            <div className="logo-container col-8">
              <HeaderLogo align="left" both height="auto" width="100px" />
            </div>

            {isLightBox && (
              <SubscriberButtons
                goToLogin={goToLogin}
                handleCloseButton={handleCloseButton}
                isAuthenticated={isAuthenticated}
                isBadConnection={isBadConnection}
                isMobile={isMobile}
                showCloseIcon={showCloseIcon}
              />
            )}
          </div>
          {Boolean(subTitle) && (
            <p className="subtitle" data-testid={SUBTITLE_TEXT}>
              {subTitle}
            </p>
          )}
          {isLightBox && (
            <p className="mobile-text center-align visible-xs">
              {SAVE_EIGHTY_WHERE_YOU_LIVE}
            </p>
          )}
          {showError && (
            <div
              className="alert alert__error animate--collapse-toggle animate"
              data-testid={ERROR_TEXT}
            >
              {SUBSCRIPTION_EMAIL_IS_REQUIRED}
            </div>
          )}
          {showErrorForLocation && (
            <div
              className="alert alert__error animate--collapse-toggle animate"
              data-testid={ERROR_TEXT}
            >
              {SUBSCRIPTION_LOCATION_IS_REQUIRED}
            </div>
          )}
          {showKickboxError && (
            <div
              className="alert alert__error animate--collapse-toggle animate"
              data-testid={ERROR_TEXT}
            >
              {KICKBOX_FAILED_VALIDATION}
            </div>
          )}
          <div className="subscribe-dropdown-container">
            <BareSelect
              ariaLabel="subscribe-dropdown"
              dataTestId={LOCATION_SELECT}
              dataqa="selectLocation"
              extraClasses="subscribe-dropdown"
              formId="form_input_custom3"
              name="subscribe-dropdown"
              onChange={(event) => onChangeAction(event.target.value)}
              options={updatedList}
              value={locationAux}
            />

            <Icon
              color={theme.colors.primary}
              faIcon={faMapMarkerAlt}
              size="24px"
            />
          </div>

          <p className="center-align">{AND}</p>

          {isLightBox && !isAuthenticated && (
            <div
              className="subscribe-form__google-sign-in-container"
              data-testid={GOOGLE_BUTTON}
            >
              <LoginGoogle
                isBadConnection
                subscriberPage
                title={SIGN_UP_WITH_GOOGLE}
              />
              <TextDevider />
            </div>
          )}

          <Element name={EMAIL_INPUT_SCROLL_TO_ID} />

          <div className="email-input-container">
            <Input
              onBlur={() => setOnFocus(false)}
              onChange={changeEmail}
              onFocus={() => {
                setOnFocus(true);
                if (isLightBox) {
                  try {
                    scroller.scrollTo(EMAIL_INPUT_SCROLL_TO_ID, {
                      containerId: MODALS.lightbox,
                      delay: 100,
                      duration: 200,
                      offset: -10,
                      smooth: true,
                    });
                  } catch (error) {
                    console.warn(error);
                    ErrorTrackingService.logError(error);
                  }
                }
              }}
            />

            {/* Honey pot field */}
            <label className="text-label" htmlFor="input-container">
              {LEAVE_BLANK}
            </label>
            <input
              aria-label={LEAVE_BLANK}
              autoComplete="off"
              className="input-container"
              onChange={handleHoneyPotField}
              type="text"
            />

            <Icon
              color={theme.colors.primary}
              faIcon={faEnvelope}
              size="24px"
            />
          </div>

          {suggestedMail.length > 0 && (
            <Message
              iconPosition="left"
              message={DID_YOU_MEAN + ' ' + suggestedMail}
            />
          )}
          <div className="justify legal-text">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: isLightBox
                  ? LIGHTBOX_ABOVE_BUTTON
                  : PPC_SIGN_UP[process.env.NEXT_PUBLIC_BRAND],
              }}
            />
          </div>
          <Button
            className="submit"
            dataTestId={SUBMIT_BUTTON}
            onClick={subscribe}
            text={buttonText || GO_TO_DEALS}
          />
          {isLightBox && (
            <div className="justify legal-text" style={{ marginTop: '10px' }}>
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: LIGHTBOX_BELOW_BUTTON,
                }}
              />
            </div>
          )}
        </div>
      </div>

      {getSubscriberStyle(theme)}
    </>
  );
};

Subscriber.propTypes = {
  buttonText: PropTypes.string,
  defaultLocation: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  isBadConnection: PropTypes.bool,
  isLightBox: PropTypes.bool,
  isLocation: PropTypes.bool,
  list: PropTypes.array.isRequired,
  redirectUrl: PropTypes.string,
  setShowModal: PropTypes.func,
  showCloseIcon: PropTypes.bool,
  subTitle: PropTypes.string,
};
